import * as React from "react";
import {option, Option} from "ts-option";
import DictionaryItem from "../../../model/dictionary/DictionaryItem";
import {RouteComponentProps, withRouter} from "react-router";
import {connect} from "react-redux";
import {RootState} from "../../../store/reducer/root/RootState";
import {api} from "../../../api/api";
import "./activityTemplateDetails.scss";
import {Dispatch} from "redux";
import {fetchActivityTemplates, fetchJobActivityTemplates} from "../../../store/action/survey/survey";
import EditActivityTemplate from "./EditActivityTemplate";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";

interface IRouteProps {
	activityId: string
}

interface IReduxProps {
	/**
	 * Selected activity templates
	 */
	jobActivityTemplate: Option<DictionaryItem>;
	/**
	 * Activity templates
	 */
	activityTemplates: Option<DictionaryItem[]>;
	/**
	 * Job activity templates
	 */
	jobActivityTemplates: Option<DictionaryItem[]>;
	/**
	 * Task
	 */
	tasks: DictionaryItem[]
}

interface IDispatchProps {
	fetchJobActivityTemplates: () => void
	fetchActivityTemplates: () => void
}

type Props = IReduxProps & IDispatchProps & RouteComponentProps<IRouteProps>

class JobActivityTemplateDetails extends React.Component<Props> {

	componentDidMount(): void {
		if (this.props.jobActivityTemplate.isEmpty) {
			this.props.fetchJobActivityTemplates();
		}
		if (this.props.activityTemplates.isEmpty) {
			this.props.fetchActivityTemplates();
		}
	}


	render() {
		return (
			<EditActivityTemplate {...this.props}
								  activityTemplate={this.props.jobActivityTemplate}
								  downloadTaskItems={(taskId) => {return api.instance.taskApi.downloadTaskItems(taskId)}}
								  setActivityTemplateTasks={(tasks) => {
									  return api.instance.activityTemplateApi.setJobActivityTemplateTasks(
										  this.props.match.params.activityId, tasks)
								  }}
								  fetchActivityTemplateTasks={() => {
									  return api.instance.activityTemplateApi.fetchJobActivityTemplateTasks(
										  this.props.match.params.activityId)
								  }}/>
		)
	}
}

function mapStateToProps(state: RootState, props: RouteComponentProps<IRouteProps>) {
	const template = state.survey.jobActivityTemplates.flatMap(templates => {
		return option(templates.filter(t => t.id == props.match.params.activityId)[0])
	});
	const tasksAsDictionaryItems = state.task.tasks.getOrElse([])
		.sort((a, b) => a.title.localeCompare(b.title))
		.map(task => new DictionaryItem(task.id, task.title));
	const activityTemplates = state.survey.activityTemplates;
	const jobActivityTemplates = state.survey.jobActivityTemplates;
	return {
		jobActivityTemplate: template,
		activityTemplates,
		jobActivityTemplates,
		tasks: tasksAsDictionaryItems
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchActivityTemplates: () => dispatch(
			fetchActivityTemplates(() => {}, (error) => notifyBugsnagAndShowToast(error, "Fetch activity templates"))),
		fetchJobActivityTemplates: () => dispatch(
			fetchJobActivityTemplates(() => {}, (error) => notifyBugsnagAndShowToast(error, "Fetch job activity templates")))
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobActivityTemplateDetails))